var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.219 35.998C-3.407 24.521.525 9.845 12.002 3.218c11.477-6.625 26.153-2.693 32.78 8.784 6.626 11.477 2.693 26.153-8.784 32.78-11.477 6.626-26.153 2.693-32.78-8.784z",
    fill: "#FD1C56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 20.902c2 1.155 2 4.041 0 5.196l-9.75 5.63c-2 1.154-4.5-.29-4.5-2.599V17.871c0-2.31 2.5-3.753 4.5-2.598l9.75 5.629z",
    fill: "#F4F4F4"
  })));
}
export default SvgPlay;